
import request from '@/utils/request'

/**
 * 获取组织树形结构
 * @param {Object} params 请求参数
 * @returns {Promise} 返回Promise对象
 */
export function listOrgTree(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/org.listOrgTree',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

export function saveOrg(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/org.saveOrg',
      method: 'post',
      data: params
    }).then(response => {
      resolve(response.data)
    }).catch(error => {
      reject(error)
    })
  })
}

export function listOrgs(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/org.listOrgs',
      method: 'get',
      params
    }).then(response => {
      resolve(response.data)
    }).catch(error => {
      reject(error)
    })
  })
}

export function updateOrg(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/org.updateOrg',
      method: 'post',
      data: params
    }).then(response => {
      resolve(response.data)
    }).catch(error => {
      reject(error)
    })
  })
}

export function deleteOrg(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/org.deleteOrg',  
      method: 'post',
      data: params
    }).then(response => {
      resolve(response.data)
    }).catch(error => {
      reject(error)
    })
  })
}

export function listStaffsNoInOrg(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/user.listStaffsNoInOrg',
      method: 'get',
      params
    }).then(response => {
      resolve(response.data)
    }).catch(error => { 
      reject(error)
    })
  })
}
export function saveStaffOrgRel(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/org.saveStaffOrgRel',
      method: 'post',
      data: params
    }).then(response => {
      resolve(response.data)
    }).catch(error => {
      reject(error)
    })
  })
}

export function deleteStaffOrgRel(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/org.deleteStaffOrgRel',
      method: 'post',
      data: params
    }).then(response => {
      resolve(response.data)
    }).catch(error => { 
      reject(error)
    })
  })
}

export function deleteOrgRelStaff(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/org.deleteOrgRelStaff',
      method: 'post',
      data: params
    }).then(response => {
      resolve(response.data)
    }).catch(error => { 
      reject(error)
    })
  })
} 





